/**
 * Type-safe way to filter out undefined entries from an array.
 * @param array The array to filter.
 * @returns An array without null or undefined entries, typed without null or undefined.
 */
export function getAllDefinedArrayEntries<T>(array: (T | undefined)[]): T[] {
  return array.filter((entry): entry is T => !!entry);
}
